<template>
    <div class="contentchart">
        <div class="chart">
            <div class="chart-info">
               <div class="info-title">
                    <div class="title-icon">
                        <img src="@/assets/appraisal/title-icon.png" alt="">
                    </div>
                    <div class="title-text">
                        <span>签到方式分布</span>
                    </div>
               </div>
               <div class="info-content">
                    <SignIn :SiginInfo="SiginInfo" />
               </div>
            </div>
        </div>
        <div class="chart">
            <div class="chart-info">
                 <div class="info-title">
                    <div class="title-icon">
                        <img src="@/assets/appraisal/title-icon.png" alt="">
                    </div>
                    <div class="title-text">
                        <span>人工干预占比</span>
                    </div>
               </div>
               <div class="info-content">
                    <Artificial :ArtificialInfo="ArtificialInfo" />
               </div>
            </div>
        </div>
        <div class="chart">
            <div class="chart-info">
                 <div class="info-title">
                    <div class="title-icon">
                        <img src="@/assets/appraisal/title-icon.png" alt="">
                    </div>
                    <div class="title-text">
                        <span>预约签到趋势</span>
                    </div>
               </div>
               <div class="info-content">
                    <Appointment :AppointmentInfo="AppointmentInfo" />
               </div>
            </div>
        </div>
        <div class="chart">
            <div class="chart-info">
                 <div class="info-title">
                    <div class="title-icon">
                        <img src="@/assets/appraisal/title-icon.png" alt="">
                    </div>
                    <div class="title-text">
                        <span>人工干预趋势</span>
                    </div>
               </div>
               <div class="info-content">
                    <Intervention :InterventionInfo="InterventionInfo" />
               </div>
            </div>
        </div>
    </div>
</template>
<script>
    import SignIn from '../SignIn/index.vue'
    import Artificial from '../Artificial/index.vue'
    import Appointment from '../Appointment/index.vue'
    import Intervention from '../Intervention/index.vue'
    import { getSiginInfo,getArtificial,getAppointmentInfo,getInterventionInfo} from '@/api/industrialInjury/statistics'

    export default {
        name: 'statisticsInfo',
        components: {
            SignIn,
            Artificial,
            Appointment,
            Intervention
        },
        data() {
            return {
                SiginInfo:[],
                ArtificialInfo:[],
                AppointmentInfo:{},
                InterventionInfo:{},
            }
        },
        created() {
        },
        methods: {
            getSigin(data){
                getSiginInfo(data).then(res => {
                    if(res.code == 200){
                        this.SiginInfo = res.data
                    }
                })
            },
            getArtificial(data){
                getArtificial(data).then(res => {
                    if(res.code == 200){
                        this.ArtificialInfo = res.data
                    }
                })
            },
            getAppointment(data){
                getAppointmentInfo(data).then(res => {
                    if(res.code == 200){
                       const name = []
                       const yuyueCounts = []
                       const qiandaoCounts = []
                        res.data.forEach(item => {
                            name.push(item.name ); 
                            yuyueCounts.push(item.yuyueCount);
                            qiandaoCounts.push(item.qiandaoCount);
                        });
                        this.AppointmentInfo = {
                            name: name,
                            yuyueCount: yuyueCounts,
                            qiandaoCount: qiandaoCounts
                        };
                    }
                })
            },
            getIntervention(data){
                getInterventionInfo(data).then(res => {
                    if(res.code == 200){
                        const name = []
                        const xianchangRate = []
                        const rengongRate = []
                        res.data.forEach(item => {
                            name.push(item.name ); 
                            xianchangRate.push(item.xianchangRate);
                            rengongRate.push(item.rengongRate);
                        });
                        this.InterventionInfo = {
                            name: name,
                            xianchangRate: xianchangRate,
                            rengongRate: rengongRate
                        };
                        console.log(this.InterventionInfo,'当前折线图的数据')
                    }
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
.contentchart{
   width: 100%;
   height: 100%;
   display: flex;
   flex-wrap: wrap;
   align-items: center;
   justify-content: space-between;
   gap: 20px;
    .chart{
        width: 760px;
        height: 362px;
        .chart-info{
            width: 100%;
            height: 100%; 
            max-width: 100%;
            background: var(--color-background-mute-soft);
            border: 1px solid var(--color-border-soft);
            padding: 24px;
            box-sizing: border-box;
            border-radius: 8px;
            display: flex;
            flex-direction: column;
            overflow: hidden;
            
            .info-title{
                height: 30px;
                min-height: 30px;
                display: flex;
                align-items: center;
                flex-shrink: 0;
                width: 100%;
                
                .title-icon{
                    width: 18px;
                    height: 18px;
                    margin-right: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                    
                    img{
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }
                
                .title-text{
                    color: var(--vt-c-black-mute-soft);
                    font-weight: var(--font-weight-normal);
                    font-size: var(--font-size-large);
                    font-weight: 600;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
            
            .info-content{
                flex: 1;
                min-height: 0;
                width: 100%;
                max-width: 100%;
                position: relative;
                overflow: hidden;
                box-sizing: border-box;
            }
        }
    }
}
</style>